import { render, staticRenderFns } from "./RecordsDetail.vue?vue&type=template&id=3ba9141a&scoped=true"
import script from "./RecordsDetail.vue?vue&type=script&lang=js"
export * from "./RecordsDetail.vue?vue&type=script&lang=js"
import style0 from "./RecordsDetail.vue?vue&type=style&index=0&id=3ba9141a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba9141a",
  null
  
)

export default component.exports